import { ValidatorFn, AbstractControl } from '@angular/forms';
import { setError } from './setError';

export function CallbackValidator(validate: (value: any) => boolean): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        if (control.pristine) {
            return null;
        }

        const valid = validate(control.value);
        const error = valid ? null : { callback: true };

        setError(control, error, 'callback');

        return error;
    };
}
